import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarSyncService {
  private refreshUploadCountSource = new Subject<void>();
  private refreshRhUploadCountSource = new Subject<void>();
  refreshUploadCount$ = this.refreshUploadCountSource.asObservable();
  refreshRhUploadCount$ = this.refreshRhUploadCountSource.asObservable();

  triggerUploadCountRefresh() {
    this.refreshUploadCountSource.next();
  }

  triggerRHUploadCountRefresh() {
    this.refreshRhUploadCountSource.next();
  }
}
